/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { termsEditorCommon as terms } from "../../terms/common";
import { Editor } from "../../Editor";

export enum MENU_ID {
	SUPPORT = "main.support",
	INSPIRATION = "main.inspiration"
}

export function registerCoreMenus(dc: Editor): void {
	const menuSvc = dc.get("menuService");
	const productSupportSvc = dc.get("productSupportService");

	menuSvc.registerMenu({
		id: "main.create"
	});

	menuSvc.registerMenu({
		id: "main.manage"
	});

	menuSvc.registerMenu({
		id: "main.monitor"
	});

	menuSvc.registerMenuItem("main.manage", {
		id: "errors",
		label: terms.mainMenu.sectionMonitor.errors.label,
		tooltip: terms.mainMenu.sectionMonitor.errors.tooltip,
		icon: "mdi/alert",
		flags: [],
		order: 50,
		commandId: "envErrors.open"
	});

	menuSvc.registerMenu({
		id: "main.tools"
	});

	menuSvc.registerMenuItem("main.tools", {
		id: "importBlueprint",
		label: terms.mainMenu.sectionTools.importBlueprint.label,
		tooltip: terms.mainMenu.sectionTools.importBlueprint.tooltip,
		icon: "mdi/import",
		flags: [],
		order: 30,
		commandId: "importBlueprint.open"
	});

	menuSvc.registerMenuItem("main.tools", {
		id: "autloginAppUser",
		label: "Auto-Login App User",
		tooltip: "Automatically log in as an application user for testing purposes. Runs an action configured in app config.",
		icon: "mdi/account-key",
		flags: [],
		order: 40,
		commandId: "environment.autloginAppUser"
	});

	menuSvc.registerMenuItem("main.tools", {
		id: "reloadServer",
		label: "Reload Server",
		tooltip: "Reload the application server and all blueprints.",
		icon: "mdi/reload",
		flags: [],
		order: 45,
		commandId: "server.reload"
	});

	menuSvc.registerMenuItem("main.tools", {
		id: "openReferenceGuide",
		label: "Reference Guide",
		tooltip: "Open the Adapptio Reference Guide documentation.",
		icon: "mdi/bookshelf",
		flags: [],
		order: 50,
		commandId: "referenceGuide.open",
	});

	/** DOCUMENTATION */

	menuSvc.registerMenu({
		id: MENU_ID.SUPPORT
	});

	const supportItems = productSupportSvc.getSupportMenuItems();

	for (let i = 0; i < supportItems.length; i++) {
		const item = supportItems[i];

		menuSvc.registerMenuItem(MENU_ID.SUPPORT, item);
	}

	/** INSPIRATION */

	menuSvc.registerMenu({
		id: MENU_ID.INSPIRATION
	});

	const inspirationItems = productSupportSvc.getInspirationMenuItems();

	for (let i = 0; i < inspirationItems.length; i++) {
		const item = inspirationItems[i];

		menuSvc.registerMenuItem(MENU_ID.INSPIRATION, item);
	}

	// -- Create
	menuSvc.registerMenuItem("main.create", {
		id: "directory",
		label: terms.mainMenu.sectionCreate.directory.label,
		tooltip: terms.mainMenu.sectionCreate.directory.tooltip,
		icon: "mdi/folder",
		flags: [ "primary" ],
		order: 0,
		commandId: "resource.create.directory"
	});

	// -- Manage
	menuSvc.registerMenuItem("main.manage", {
		id: "config",
		label: terms.mainMenu.sectionManage.appConfig.label,
		tooltip: terms.mainMenu.sectionManage.appConfig.tooltip,
		icon: "mdi/cog",
		flags: [],
		order: 20,
		commandId: "appConfig.open"
	});
}
